import { render, staticRenderFns } from "./CalendarioServiziList.vue?vue&type=template&id=116d5670&"
import script from "./CalendarioServiziList.vue?vue&type=script&lang=ts&"
export * from "./CalendarioServiziList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports